import { render } from "./Edit.vue?vue&type=template&id=29b100f2&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-29b100f2"

export default script